module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-course-center"
  }, [_c('div', {
    staticClass: "clearfix index-title-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right index-title-more"
  }, [_c('span', {
    staticClass: "nb-a",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/' + _vm.topic.location + '/introduction')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t更多\n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-caret-square-o-right color-main"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article.loading),
      expression: "article.loading"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "index-content-block",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left index-title"
  }, [_c('i', {
    staticClass: "fa fa-envelope-open-o"
  }), _vm._v("\n\t\t\t课程简介\n\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b380f1c4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/index/widget/IndexCourseCenter.vue
// module id = 1018
// module chunks = 1